import React from 'react';
import { withRouter } from 'react-router-dom';
import { trackPinterestEvent } from './helpers/analytics'

class PinterestAnalytics extends React.Component {

    componentWillUpdate({ location, history }) {

        if (location.pathname === this.props.location.pathname) {
            // don't log identical link clicks
            return;
        }

        trackPinterestEvent('pagevisit');
    }

    render() {
        return null;
    }
}

export default withRouter(PinterestAnalytics);